import { render, staticRenderFns } from "./SetCredit.component.vue?vue&type=template&id=5ddff606"
import script from "./SetCredit.component.vue?vue&type=script&lang=ts"
export * from "./SetCredit.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports